import { createAuthClient } from "better-auth/react";
import { emailOTPClient } from "better-auth/client/plugins";
import { passkeyClient } from "@better-auth/passkey/client";

type AnyAuthClient = any;

export const authClient: AnyAuthClient = createAuthClient({
  baseURL: `${window.location.origin}/api/auth`,
  plugins: [emailOTPClient(), passkeyClient()],
});

export const useSession = authClient.useSession as AnyAuthClient;
export const signOut = authClient.signOut as AnyAuthClient;
